import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=35fb27ee"
import script from "./ViewSelector.vue?vue&type=script&lang=js"
export * from "./ViewSelector.vue?vue&type=script&lang=js"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=35fb27ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports